import { motion } from 'framer-motion';
import React from 'react';
import { fadeInVariants, shouldReduceMotion } from 'src/tef/components/config/animationConfig';
import { ComponentVariant } from 'src/tef/components/utils/types';

interface FadeInAnimationProps {
  children: React.ReactNode;
  variant?: ComponentVariant & { duration?: 'fast' | 'normal' | 'slow'; delay?: number };
  delay?: number;
  className?: string;
}

export const FadeInAnimation: React.FC<FadeInAnimationProps> = ({
  children,
  variant = {},
  delay: delayProp,
  className,
}) => {
  const duration = variant.duration || 'normal';
  const delay = delayProp ?? variant.delay ?? 0;
  const reduceMotion = shouldReduceMotion();

  const animationVariants = reduceMotion
    ? {
        hidden: { opacity: 1 },
        visible: { opacity: 1 },
        exit: { opacity: 1 },
      }
    : {
        hidden: fadeInVariants.hidden,
        visible: {
          opacity: 1,
          transition: {
            duration: duration === 'fast' ? 0.2 : duration === 'slow' ? 0.5 : 0.3,
            delay,
            ease: [0.4, 0, 0.2, 1],
          },
        },
        exit: fadeInVariants.exit,
      };

  return (
    <motion.div initial="hidden" animate="visible" exit="exit" variants={animationVariants} className={className}>
      {children}
    </motion.div>
  );
};

FadeInAnimation.displayName = 'FadeInAnimation';
